import {
  animate,
  style,
  transition,
  trigger,
  animateChild,
  group,
  query,
} from '@angular/animations';

export const fadeSwitch = trigger('fadeSwitch', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('200ms', style({ opacity: 1 })),
  ]),
  transition(':leave', [
    style({ opacity: 1 }),
    animate('0ms', style({ opacity: 0 })),
  ]),
]);

export const backdropAnimation = trigger('backdropAnimation', [
  transition(':enter', [
    group([
      query(':self', [style({ opacity: 0 }), animate('400ms ease-in-out')]),
      query('@slideInOutAnimation', animateChild(), { optional: true }),
    ]),
  ]),
  transition(':leave', [
    group([
      query(':self', [animate('400ms ease-in-out'), style({ opacity: 0 })]),
      query('@slideInOutAnimation', animateChild(), { optional: true }),
    ]),
  ]),
]);

export const slideInOutAnimation = [
  trigger('slideInOutAnimation', [
    transition(':enter', [
      style({ transform: 'translate3d(-100%, 0, 0)' }),
      animate(
        '100ms ease-in-out',
        style({ transform: 'translate3d(0, 0, 0)' })
      ),
    ]),
    transition(':leave', [
      style({ transform: 'translate3d(0, 0, 0)' }),
      animate(
        '100ms ease-in-out',
        style({ transform: 'translate3d(-100%, 0, 0)' })
      ),
    ]),
  ]),
];

export const modalAnimation = [
  trigger('fadeInOut', [
    transition(':enter', [
      style({ opacity: 0 }),
      group([
        animate('150ms ease-in-out', style({ opacity: 1 })),
        query('@scaleInOut', animateChild(), { optional: true })
      ])
    ]),
    transition(':leave', [
      group([
        animate('150ms ease-in-out', style({ opacity: 0 })),
        query('@scaleInOut', animateChild(), { optional: true })
      ])
    ])
  ]),
  trigger('scaleInOut', [
    transition(':enter', [
      style({ transform: 'scale(0.9)' }),
      animate('150ms ease-in-out', style({ transform: 'scale(1)' }))
    ]),
    transition(':leave', [
      style({ transform: 'scale(1)' }),
      animate('150ms ease-in-out', style({ transform: 'scale(0.9)' }))
    ])
  ])
]
